/**
 * @file   src\mobile\components\createWantAd\Interior.js
 * @brief  This file is responsible for nice to haves section subcomponent
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Interior = (props) => {
  const { interior, handleItemClick, itemArray } = props;
  return (
    <NiceToHaveHelper
      list={interior}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Interior;
